import "./NewHomePage.css"
import React, {FunctionComponent, useEffect, useRef, useState} from "react"
import {useSelector} from "react-redux";
import {ApplicationState} from "../../../core/types";
import RSSReader, {RSSReaderHandle} from "../components/rssreader/RSSReader";
import AppModuleUI from "../components/appmodule/AppModuleUI";
import {GetModules} from "../components/appmodulemgr/AppModuleMgr";
import PageHeader from "../components/pageheader/PageHeader";
import InfoItem from "../components/infoitem/InfoItem";
const txt_title = "SMRT Link";
const txt_subtitle = "Your sequencing command center";
const txt_whatsnew = "WHAT'S NEW";
const txt_workflows = "WORKFLOWS";

const ModulesTable: React.FC = () => {
    const modules = GetModules(false);
    const leftColumn: React.ReactElement[] = [];
    const rightColumn: React.ReactElement[] = [];

    modules.forEach((module, index) => {
        const uiModule = AppModuleUI(module);
        if (index % 2 === 0) {
            leftColumn.push(uiModule);
        } else {
            rightColumn.push(uiModule);
        }
    });

    return (
        <div className="newhome-modules-columns">
            <div className="newhome-modules-column">
                {leftColumn.map((item, idx) => (
                    <div key={`left-${idx}`} className="newhome-module">
                        {item}
                    </div>
                ))}
            </div>
            <div className="newhome-modules-column">
                {rightColumn.map((item, idx) => (
                    <div key={`right-${idx}`} className="newhome-module">
                        {item}
                    </div>
                ))}
            </div>
        </div>
    );
};

const HomeInfo: React.FC = () => {
    return (
        <div className="info-item-container">
            <InfoItem title="2 instruments online" dotcolor="var(--green-bright-color)"/>
            <InfoItem title="3 runs in progress" dotcolor="var(--green-bright-color)"/>
            <InfoItem title="847 GB data this week" dotcolor="var(--green-bright-color)"/>
        </div>
    );
}

export const NewHomePage: FunctionComponent = () => {
    const readerRef = useRef<RSSReaderHandle>(null);
    const [rssOK, setRssOK] = useState<boolean | null>(null);
    const rssFeedUrl = useSelector<ApplicationState, string>(state => state.dev.rssFeedUrl);

    useEffect(() => {
        void (async () => {
            const result = await readerRef.current?.Connect(rssFeedUrl);
            setRssOK(result ?? false);
        })();
    }, [rssFeedUrl]);

    const newsBorderStyle: React.CSSProperties = {
        borderLeft: rssOK ? "1px solid var(--gray-light-color)" : "1px solid transparent"
    };

    return (
        <div className="newhome-container">
            <PageHeader title={txt_title} subtitle={txt_subtitle} info={<HomeInfo/>}/>
            <div className="newhome">
                <div className="newhome-left">
                    <div className="newhome-section-title">{txt_workflows}</div>
                    <div className="newhome-modules">
                        <div className="newhome-modules-columns">
                            <ModulesTable/>
                        </div>
                    </div>
                </div>
                <div className="newhome-right">
                    <div className="newhome-news" style={newsBorderStyle}>
                        {rssOK &&
                            <div className="newhome-section-title">{txt_whatsnew}</div>
                        }
                        <div className="newhome-news-column">
                            <RSSReader ref={readerRef}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
